import { render, staticRenderFns } from "./NoticeState.vue?vue&type=template&id=0b521431&scoped=true"
import script from "./NoticeState.vue?vue&type=script&lang=js"
export * from "./NoticeState.vue?vue&type=script&lang=js"
import style0 from "./NoticeState.vue?vue&type=style&index=0&id=0b521431&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b521431",
  null
  
)

export default component.exports